<template>
	<div class="recharge-page">
		<!-- 顶部导航 -->
		<div class="header">
			<img src="/img/newLogin/download.png" @click="back()" class="back-icon" />
			<span class="title">{{ $t('recharge.recharge') || 'Recharge' }}</span>
			<img src="/img/kefu.png" @click="$router.push('/ServiceOnline')" class="service-icon" />
		</div>

		<!-- 余额背景横幅 -->
		<div class="balance-banner">

			<div class="balance-content">
				<span class="balance-val">${{ balance }}</span>
				<span class="balance-label">{{ $t('my.balance') || 'Balance' }}</span>
			</div>
		</div>

		<!-- 主体内容区 -->
		<div class="main-content">
			<div class="sel-box u-flex u-col-center" style="color:#fff;">


				<div class="type-item u-p-y-30" v-for="(item, index) in radioOptions" :key="index">
					<div class="u-radio" style="width: 100%; flex: 0 0 100%;">
						<input type="radio" @click="radiox(item.value)" :value="item.value"
							v-model="radioValue">{{ item.label }}

					</div>
				</div>



			</div>


			<div class="qrcode">
				<div class="i-scan" style="margin-bottom:20px;">
					<div style="width:200px;height: 200px;margin: 0px auto;">
						<img :src="imgurl" style="width:200px;height: 200px;">
						
					</div>
				</div>
				<div class="text" style="margin-bottom:30px;font-size:13px;color:#fff;margin-top:5px;text-align:center;">{{url}}
				</div>
			</div>

			<div class="btns">
				<div class="form_btn">
					<button class="confirm-btn" @click="copyText">
						{{$t('Copy')}}
					</button>
				</div>
			</div>

			<!-- 输入金额 -->
			<div class="input-area">
				<span class="currency-symbol">$</span>
				<input type="number" v-model="money" class="money-input" placeholder="" />
			</div>

			<!-- 快速选择金额 -->
			<div class="quick-section">
				<div class="quick-title">{{ $t('recharge.quick_select') || 'Quick select money' }}</div>
				<div class="quick-grid">
					<div v-for="amount in quickAmounts" :key="amount" class="quick-btn"
						:class="{ active: money == amount }" @click="selectAmount(amount)">
						{{ amount }}
					</div>
				</div>
			</div>
			<div style="margin-bottom:30px;">
				<label for="fileInput" style="background: #ec0c0c;
			color: #fff;display: inline-block;
    text-align: center;padding-top: 9px;" class="confirm-btn">{{$t('Click Upload Payment Receipt')}}</label>
				<input type="file" id="fileInput" @change="handleFileUpload" style="display: none;">

				<img v-if="trademark" :src="trademark" style="width:100%"/>
			</div>
			<!-- 确认按钮 -->
			<button class="confirm-btn" @click="onSubmit">
				{{ $t('recharge.confirm') || 'Confirm' }}
			</button>

			<!-- 提示语 -->
			<!--<div class="tip-text">
				{{ $t('recharge.tip') || 'Tip: Please contact customer service after recharge' }}
			</div>-->
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'RechargePage',

		data() {
			return {
				balance: '0.00',
				money: '',
				radioValue: 'USDT-TRC20',
				imgurl: '',
				url: '',
				trcurl: '',
				trademark: '',
				trcimgurl: '',
				ercurl: '',
				ercimgurl: '',
				btcurl: '',
				btcimgurl: '',
				radioOptions: [{
						label: 'USDT-TRC20',
						value: 'USDT-TRC20'
					},
					{
						label: 'USDC',
						value: 'USDC'
					},
					{
						label: 'BTC',
						value: 'BTC'
					},
					{
						label: 'Bank',
						value: 'Bank'
					}
				],
				quickAmounts: [50, 100, 200, 500, 1000, 3000, 5000, 10000, 30000],
			}
		},

		mounted() {
			if (this.$route.params.balance) {
				this.balance = this.$route.params.balance
			} else {
				this.getUserBalance()
			}
		},

		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			}
			this.rechargeinit();
		},

		methods: {
			back() {
				window.history.back()
			},
			handleFileUpload(event) {
				/*eslint-disable*/
				let file = event.target.files[0]; // 获取第一个选中的文件
				if (file) {
					// 创建一个FormData对象
					const formData = new FormData();
					formData.append('file', file); // 将文件添加到FormData对象中
					axios.post('https://admin.7tw-eleven.com/api/system/uploadimg', formData, {
						headers: {
							'Content-Type': 'multipart/form-data', // 设置正确的Content-Type头部信息，这对于表单数据很重要。通常axios会自动设置，但显式设置也无妨。
						}
					}).then(res => {
						console.log(res);
						if (res.data.code === 200) {
							this.trademark='https://admin.7tw-eleven.com/' + res.data.data;
						}
					}).catch(error => {
						console.error('Error uploading image', error); // 上传失败的处理逻辑。
					});
				}
			},
			radiox(e) {

				this.radioValue = e;
				if (this.radioValue == 'USDC') {
					this.url = this.ercurl;
					this.imgurl = this.ercimgurl;
				} else if (this.radioValue == 'USDT-TRC20') {
					this.url = this.trcurl;
					this.imgurl = this.trcimgurl;
				} else if (this.radioValue == 'Bank') {
					const service = this.$store.getters.getBaseInfo;
					console.log(service)
					if (service.iskefu == 1) {
						console.log('ssss')
						this.url = this.ercurl;
						this.imgurl = this.ercimgurl;
						window.location.href = service.kefu

					}
				} else {
					this.url = this.btcurl;
					this.imgurl = this.btcimgurl;
				}
			},
			selectAmount(amount) {
				this.money = amount
			},
			async copyText() {

				try {
					await navigator.clipboard.writeText(this.url)
					this.$toast(this.$t('CopySuccess'))
				} catch (err) {
					console.error('复制失败:', err)
					//this.showMessage(`复制失败: ${err}`, 'error')
				}
			},
			rechargeinit() {
				this.$http({
					method: 'get',
					url: 'recharge_init'
				}).then(res => {
					if (res.code === 200) {
						this.url = res.data[0].lang;
						this.imgurl = 'https://admin.7tw-eleven.com/' + res.data[0].url;
						this.trcurl = res.data[0].lang;
						this.trcimgurl = 'https://admin.7tw-eleven.com/' + res.data[0].url;
						this.ercimgurl = 'https://admin.7tw-eleven.com/' + res.data[1].url;
						this.ercurl = res.data[1].lang;
						this.btcurl = res.data[2].lang;
						this.btcimgurl = 'https://admin.7tw-eleven.com/' + res.data[2].url;
					}
				}).catch(() => {})
			},
			getUserBalance() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.balance = res.data.money || '0.00'
					}
				}).catch(() => {})
			},
			copycode() {

			},
			onSubmit() {
				
				const money = parseFloat(this.money)
				if (!money || money <= 0) {
					this.$toast(this.$t('reservation.money_err') || 'Please enter a valid amount')
					return
				}
				if(!this.trademark){
					this.$toast(this.$t('Please upload payment voucher'))
					return
				}
				this.$http({
					method: 'post',
					url: 'rechargeupload',
					data:{
						trademark:this.trademark,
						money:money,
					}
				}).then(res => {
					if (res.code === 200) {
						this.$toast(this.$t('Submitted successfully, please wait for review'))
						this.$router.push('/Mine')
					}
				}).catch(() => {})
				
				//this.$router.push('/ServiceOnline')
			},
		},
	}
</script>

<style lang="less" scoped>
	.recharge-page {
		background-color: #1f1c1f;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* Header */
	.header {
		height: 100px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 40px;
		background-color: #1f1c1f;
		position: relative;
		z-index: 10;

		.back-icon {
			width: 40px;
			height: 30px;
			cursor: pointer;
		}

		.title {
			color: #f2c7a0;
			font-size: 36px;
			font-weight: 500;
		}

		.service-icon {
			width: 50px;
			height: 50px;
			cursor: pointer;
		}
	}

	/* Balance Banner */
	.balance-banner {
		background: linear-gradient(to right, #e2bb91, #d4a572);
		height: 240px;
		padding: 40px 60px 0;
		box-sizing: border-box;
	}

	.balance-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #000;

		.balance-val {
			font-size: 40px;
			font-weight: bold;
		}

		.balance-label {
			font-size: 36px;
			font-weight: bold;
		}
	}

	/* Main Content */
	.main-content {
		flex: 1;
		background-color: #212025;
		border-radius: 40px 40px 0 0;
		margin-top: -60px;
		padding: 60px 40px;
		position: relative;
		z-index: 5;
	}

	/* Input Area */
	.input-area {
		display: flex;
		align-items: center;
		border-bottom: 2px solid #333;
		padding-bottom: 20px;
		margin-bottom: 50px;

		.currency-symbol {
			color: #df9452;
			font-size: 56px;
			margin-right: 20px;
			font-weight: 500;
		}

		.money-input {
			flex: 1;
			background: transparent;
			border: none;
			color: #fff;
			font-size: 56px;
			outline: none;

			&::placeholder {
				color: #555;
			}
		}
	}

	/* Quick Select */
	.quick-title {
		color: #d98d4d;
		font-size: 32px;
		font-weight: bold;
		margin-bottom: 30px;
	}

	.quick-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 24px;
		margin-bottom: 60px;
	}

	.quick-btn {
		background-color: #292d37;
		border-radius: 12px;
		color: #e0e4eb;
		font-size: 36px;
		font-weight: bold;
		width: calc(33.33% - 16px);
		height: 90px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.2s;

		&:active {
			transform: scale(0.95);
		}

		&.active {
			background: linear-gradient(to bottom, #d2a473, #b88654);
			color: #3b200b;
		}
	}

	/* Confirm Button */
	.confirm-btn {
		width: 100%;
		height: 100px;
		background: linear-gradient(to bottom, #a08873, #725842);
		border: none;
		border-radius: 12px;
		color: #4a2c1d;
		font-size: 36px;
		font-weight: bold;
		cursor: pointer;
		margin-bottom: 30px;
		transition: all 0.2s;

		&:active {
			opacity: 0.9;
			transform: translateY(2px);
		}
	}

	/* Tip Text */
	.tip-text {
		color: #df9452;
		font-size: 26px;
	}

	.u-flex {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.u-col-center {
		align-items: center;
	}

	.u-p-x-24 {
		padding-left: 10px !important;
		padding-right: 10px !important;
	}

	.u-p-y-30 {
		padding-top: 12px !important;
		padding-bottom: 12px !important;
	}

	.form_btn .btn {
		background-color: #009995;
		border: none;
		font-size: 16px;
		font-weight: 500;
		color: #fff;
	}

	.form_btn .btn:after {
		content: " ";
		width: 200%;
		height: 200%;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid rgba(0, 0, 0, .2);
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		box-sizing: border-box;
		border-radius: 10px;
	}
</style>